import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import { showToast, WEBSERVICE, checkCurrencyPairAccreditedStatus, showErrorDialog } from "../../CoreDataService";
import AccreditationVerificationPopup from '../Accredited-Kyc/AccreditationVerificationPopup';
import TermsAgreementPopup from '../Accredited-Kyc/TermsAgreementPopup';
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import { DataContext } from ".";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";

const title = "Stop-Limit";
const description = `You can set an offer range depending on market price for buy or
              sell trading. For BUY - Market order price should be less than
              stop price and limit price should be greater than stop price For
              SELL - Market order price should be greater than stop price and
              limit price should be less than stop price.`;

const BuyAndSellStopLimit = ({
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  getUserTransaction,
  minBuySellAmount,
}) => {
  const { currencycode, basecurrency, ltp, setUpdateOrder } =
    useContext(DataContext);
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const tradep = localStorage.getItem("priceprc") || 6;
  const ltpdata = Number(ltp);
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => setShow(false);

  const [stopLossQuantity, setStopLossQuantity] = useState("");
  const [stopLossPrice, setStopLossPrice] = useState("");
  const [stopLossTriggerPrice, setStopLossTriggerPrice] = useState("");
  const [stopLossTotal, setStopLossTotal] = useState("");
  const [buyDisabled, setBuyDisabled] = useState(true);
  const [sellDisabled, setSellDisabled] = useState(true);
  const [error, setError] = useState("");

  const [sliderValueBuyStopLimit, setSliderValueBuyStopLimit] = useState(0);
  const [stpLoader, setStpLoader] = useState(false);
  const [isBuyDisabled, setIsBuyDisabled] = useState(true);

  const [stopLossError, setStopLossError] = useState("");
  const [stopLossErrorSell, setStopLossErrorSell] = useState("");
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);
  const [marketOrderPrice, setMarketOrderPrice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sloading, setSLoading] = useState(false);

  const [stopLossQuantitySell, setStopLossQuantitySell] = useState("");
  const [stopLossPriceSell, setStopLossPriceSell] = useState(0);
  const [stopLossTriggerPriceSell, setStopLossTriggerPriceSell] = useState(0);
  const [stopLossTotalSell, setStopLossTotalSell] = useState("");
  const [isSellDisabled, setIsSellDisabled] = useState(true);

  const validateStoplossAmount = () => {
    // if (parseFloat(stopLossQuantity) <= 0.0001) {
    //   setStopLossTotal("");
    //   setBuyDisabled(true);
    //   setSellDisabled(true);
    // } else {
    //   const total = (
    //     parseFloat(stopLossQuantity) * parseFloat(stopLossPrice)
    //   ).toFixed(tradep);
    //   setStopLossTotal(isNaN(total) ? "" : total);
    //   setBuyDisabled(false);
    //   setSellDisabled(false);
    // }
  };

  const handleStopLimitAmount = (e, type) => {
    let inputValue = e.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
    if (regex.test(inputValue)) {
      if (type === "buy") {
        setStopLossQuantity(inputValue);
        if (Number(inputValue) < Number(minBuySellAmount?.minBuyQty)) {
          showToast(
            "warning",
            `The amount must be at least ${minBuySellAmount?.minBuyQty}`
          );
          setStopLossTotal("");
          // document.getElementById("mbuy").disabled = true;
          return;
        }
        const price = (
          parseFloat(ltpdata) +
          parseFloat(ltpdata) * 0.02
        ).toFixed(tradep);
        const triggerPrice = (
          parseFloat(ltpdata) +
          parseFloat(ltpdata) * 0.01
        ).toFixed(tradep);
        const total = (parseFloat(inputValue) * parseFloat(price)).toFixed(
          tradep
        );
        setStopLossPrice(price);
        setStopLossTriggerPrice(triggerPrice);
        setStopLossTotal(isNaN(total) ? "" : total);
        setBuyDisabled(isNaN(total));

        resetSliderBuy();
      } else {
        setStopLossQuantitySell(inputValue);
        if (Number(inputValue) < Number(minBuySellAmount?.minSellQty)) {
          showToast(
            "warning",
            `The amount must be at least ${minBuySellAmount?.minSellQty}`
          );
          setStopLossTotalSell("");
          // document.getElementById("mbuy").disabled = true;
          return;
        }
        const priceSell = (
          parseFloat(ltpdata) -
          parseFloat(ltpdata) * 0.02
        ).toFixed(tradep);
        const triggerPriceSell = (
          parseFloat(ltpdata) -
          parseFloat(ltpdata) * 0.01
        ).toFixed(tradep);
        const totalSell = (
          parseFloat(inputValue) * parseFloat(priceSell)
        ).toFixed(tradep);
        setStopLossPriceSell(priceSell);
        setStopLossTriggerPriceSell(triggerPriceSell);
        setStopLossTotalSell(isNaN(totalSell) ? "" : totalSell);

        // setSellDisabled(isNaN(totalSell));
        resetSliderSell();
      }
    }
  };

  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const handleInputChange = (event) => {
    let val = parseFloat(event.target.value);
    if (val < 0) {
      setError("Price cannot be negative");
    } else {
      setError("");
    }
    setStopLossTriggerPrice(val);
  };

  const validateStoplossTriggerPrice = () => {
    resetSliderBuy();
    // if (stopLossTriggerPrice <= 0.0001) {
    //   setError("Stop-loss trigger price must be greater than 0.0001");
    //   return true;
    // } else {
    //   setError("");
    //   return false;
    // }
  };

  const validateStoplossPrice = () => {
    // if (parseFloat(stopLossPrice) <= 0.0001) {
    //   setError(true);
    //   setStopLossTotal("");
    //   return true;
    // } else {
    //   setError(false);
    //   return false;
    // }
  };

  const calculateAmountFromLimitForStopLoss = () => {
    if (stopLossPrice !== "" && stopLossQuantity !== "") {
      const total = (
        parseFloat(stopLossQuantity) * parseFloat(stopLossPrice)
      ).toFixed(tradep);
      setStopLossTotal(isNaN(total) ? "" : total);
    }
  };

  const handleStopLossPriceChange = (e) => {
    setStopLossPrice(e.target.value);
    resetSliderBuy();
  };

  const handleStopLimitTotal = (e, type) => {
    let inputValue = e.target.value;
    setStopLossTotal(inputValue);

    if (type === "buy") {
      const stopPrice = (
        parseFloat(ltpdata) +
        parseFloat(ltpdata) * 0.02
      ).toFixed(tradep);
      const triggerPrice = (
        parseFloat(ltpdata) +
        parseFloat(ltpdata) * 0.01
      ).toFixed(tradep);
      const quantity = (parseFloat(inputValue) / parseFloat(stopPrice)).toFixed(
        tradep
      );
      setStopLossTotal(inputValue);
      setStopLossPrice(stopPrice);
      setStopLossTriggerPrice(triggerPrice);
      setStopLossQuantity(isNaN(quantity) ? "" : quantity);
    } else {
      const stopPrice = (
        parseFloat(ltpdata) +
        parseFloat(ltpdata) * 0.02
      ).toFixed(tradep);
      const triggerPrice = (
        parseFloat(ltpdata) +
        parseFloat(ltpdata) * 0.01
      ).toFixed(tradep);
      const quantity = (parseFloat(inputValue) / parseFloat(stopPrice)).toFixed(
        tradep
      );
      setStopLossTotalSell(inputValue);
      setStopLossPriceSell(stopPrice);
      setStopLossTriggerPriceSell(triggerPrice);
      setStopLossQuantitySell(isNaN(quantity) ? "" : quantity);
    }
  };

  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    getBuySliderValStopLimit(closestStep);
  };

  const getBuySliderValStopLimit = (newSliderValue) => {
    setStpLoader(true);
    const newBuybalanceLimit = parseFloat(selectedSellingAssetBalance);

    const calculatedStopLossPrice = (ltpdata + ltpdata * 0.02)?.toFixed(tradep);
    console.log("calculatedStopLossPrice", calculatedStopLossPrice);
    const calculatedStopLossTriggerPrice = (ltpdata + ltpdata * 0.01)?.toFixed(
      tradep
    );
    const calculatedStopLossQuantity = (
      (newBuybalanceLimit * (newSliderValue / 100) -
        newBuybalanceLimit * (newSliderValue / 100) * percentageValue) /
      parseFloat(calculatedStopLossPrice)
    ).toFixed(tradep);
    const calculatedStopLossTotal = (
      parseFloat(calculatedStopLossPrice) *
      parseFloat(calculatedStopLossQuantity)
    ).toFixed(tradep);

    setStopLossPrice(calculatedStopLossPrice);
    setStopLossTriggerPrice(calculatedStopLossTriggerPrice);
    setStopLossQuantity(calculatedStopLossQuantity);
    setStopLossTotal(calculatedStopLossTotal);
    // setIsBuyDisabled(parseFloat(calculatedStopLossQuantity) <= 0.0001);
    setStpLoader(false);
  };

  const doBuyStopLoss = async (marketOrderPrice) => {
    if (
      marketOrderPrice < stopLossTriggerPrice &&
      marketOrderPrice < stopLossPrice &&
      stopLossTriggerPrice < stopLossPrice
    ) {
      const inputObj = {
        buying_asset_code: currencycode?.toUpperCase(),
        selling_asset_code: basecurrency?.toUpperCase(),
        quantity: stopLossQuantity,
        stop_loss_price: stopLossPrice,
        trigger_price: stopLossTriggerPrice,
        txn_type: "1",
        uuid: localStorage.getItem("uuid"),
      };

      try {
        const response = await axios.post(
          `${WEBSERVICE}userTrade/StopLossBuySellTrade`,
          JSON.stringify(inputObj),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        );

        const result = response.data;
        if (result.error.error_data !== 0) {
          setLoading(false);
          if (result.error.error_data === 2) {
            showErrorDialog(result);
          } else {
            showToast("error", result.error.error_msg);
          }
        } else {
          showToast("success", result.error.error_msg);
          setStopLossPrice("");
          setStopLossTriggerPrice("");
          setStopLossQuantity("");
          setStopLossTotal("");
          setProgress(0);
          getUserTransaction();
          setUpdateOrder((prev) => !prev);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error placing order:", error);
        showToast("error", "An error occurred while placing the order.");
      }
    } else {
      setLoading(false);
      setStopLossError(
        "*Market order price should be less than stop price and limit price should be greater than stop price"
      );
    }
    setLoading(false);
  };

  const buyStopLoss = async () => {
    setLoading(true);
    setStopLossError("");

    if (!stopLossPrice || !stopLossTriggerPrice || !stopLossQuantity) {
      showToast("warning", "Please Provide Proper Details");
      setLoading(false);
      return;
    }
    if (parseFloat(stopLossQuantity) <= 0.0001) {
      setLoading(false);
      showToast("error", "Amount should be greater than 0.0001");
      return;
    }
    const marketOrderPrice = parseFloat(ltpdata);

    if (!marketOrderPrice) {
      setStopLossError("*Orderbook depth reached, price not found");
      setLoading(false);
      return;
    }

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      basecurrency?.toUpperCase(),
      currencycode?.toUpperCase(),
      'BUY',
      stopLossQuantity
    );

    if (!accreditationResult.accessAllowed) {
      setLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doBuyStopLoss(marketOrderPrice);
    };

    if (accreditationResult.requiresTermsAgreement) {
      setLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const validateStopLossAmountSell = () => {
    resetSliderSell();
    if (parseFloat(stopLossQuantitySell) <= 0.0001) {
      // setError(true);
      // setIsSellDisabled(true);
      // setStopLossTotalSell("");
    } else {
      const total = (
        parseFloat(stopLossQuantitySell) * parseFloat(stopLossPriceSell)
      ).toFixed(tradep);
      setStopLossTotalSell(isNaN(total) ? "" : total);
      setError(false);
      setIsSellDisabled(false);
    }
  };

  const validateStoplossTriggerPriceSell = (value) => {
    const price = parseFloat(value);
    // if (price <= 0.0001) {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    resetSliderSell();
    setStopLossTriggerPriceSell(value);
    validateStoplossTriggerPriceSell(value);
  };

  const validateStoplossPriceSell = () => {
    // if (parseFloat(stopLossPriceSell) <= 0.0001) {
    //   setError(true);
    //   setStopLossTotalSell("");
    // } else {
    //   setError(false);
    // }
  };

  const calculateAmountFromLimitForStopLossSell = () => {
    resetSliderSell();
    if (stopLossPriceSell !== "" && stopLossQuantitySell !== "") {
      const total = (
        parseFloat(stopLossQuantitySell) * parseFloat(stopLossPriceSell)
      ).toFixed(tradep);
      setStopLossTotalSell(isNaN(total) ? "" : total);
    }
  };

  const handleChangeSell = (event) => {
    setStopLossTotalSell(event.target.value);
    handleStopLimitTotal(event, "sell");
    resetSliderSell();
  };

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellSliderValStopLimit(closestStep);
  };
  const validateStoplossAmountSell = () => {
    if (stopLossQuantitySell <= 0.0001) {
      //   document.querySelector(".onlySellError2").style.display = "block";
      //   document.getElementById("mbuy").disabled = true;
      //   document.getElementById("msell").disabled = true;
      //   setStopLossTotalSell("");
    } else {
      let total = (
        parseFloat(stopLossQuantitySell) * parseFloat(stopLossPriceSell)
      ).toFixed(tradep);
      setStopLossTotalSell(isNaN(total) ? "" : total);
      //   document.querySelector(".onlySellError2").style.display = "none";
      //   document.getElementById("mbuy").disabled = false;
      //   document.getElementById("msell").disabled = false;
    }
    // return stopLossQuantitySell <= 0.0001;
  };

  console.log("total spot", stopLossTotalSell);

  const getSellSliderValStopLimit = (newSliderValue) => {
    setStpLoader(true);

    const newBuybalanceLimit = parseFloat(selectedBuyingAssetBalance);
    const stopLossPriceSell = (ltpdata - ltpdata * 0.02).toFixed(tradep);
    const stopLossQuantitySell = newBuybalanceLimit * (newSliderValue / 100);
    const stopLossTriggerPriceSell = (ltpdata - ltpdata * 0.01).toFixed(tradep);
    const stopLossTotalSell =
      parseFloat(stopLossPriceSell) * parseFloat(stopLossQuantitySell);
    setStopLossPriceSell(stopLossPriceSell);
    setStopLossQuantitySell(stopLossQuantitySell);
    setStopLossTriggerPriceSell(stopLossTriggerPriceSell);
    setStopLossTotalSell(stopLossTotalSell);

    // document.getElementById("customRange3").classList.toggle("changeBackgroundSlider", value === 4);
    // document.querySelector(".onlySellBtnStopLimit").disabled = stopLossQuantitySell <= 0.0001;

    validateStoplossAmountSell();
    setStpLoader(false);
  };

  const doSellStoploss = async (marketOrderPrice) => {
    if (
      marketOrderPrice > stopLossTriggerPriceSell &&
      marketOrderPrice > stopLossPriceSell &&
      stopLossTriggerPriceSell > stopLossPriceSell
    ) {
      const inputObj = {
        buying_asset_code: basecurrency?.toUpperCase(),
        selling_asset_code: currencycode?.toUpperCase(),
        quantity: stopLossQuantitySell,
        stop_loss_price: stopLossPriceSell,
        trigger_price: stopLossTriggerPriceSell,
        txn_type: "2",
        uuid: localStorage.getItem("uuid"),
      };

      try {
        const response = await axios.post(
          `${WEBSERVICE}userTrade/StopLossBuySellTrade`,
          inputObj,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        );

        const result = response.data;
        if (result.error.error_data !== 0) {
          setSLoading(false);
          if (result.error.error_data === 2) {
            showErrorDialog(result);
          } else {
            showToast("error", result.error.error_msg);
          }
        } else {
          setStopLossPriceSell("");
          setStopLossTriggerPriceSell("");
          setStopLossQuantitySell("");
          setStopLossTotalSell("");
          setSliderValue(0);
          showToast("success", result.error.error_msg);
          getUserTransaction();
          setUpdateOrder((prev) => !prev);
          setSLoading(false);
        }
      } catch (error) {
        setSLoading(false);
        showToast("error", "An error occurred while placing the order");
      }
    } else {
      setSLoading(false);
      showToast(
        "error",
        "*Market order price should be greater than stop price and limit price should be less than stop price"
      );
    }
    setSLoading(false);
  };

  const sellStoploss = async () => {
    setSLoading(true);

    if (!stopLossPriceSell || !stopLossTriggerPriceSell || !stopLossQuantitySell) {
      setSLoading(false);
      showToast("error", "Please Provide Proper Details");
      return;
    }
    const marketOrderPrice = parseFloat(ltpdata || 0);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      'SELL',
      stopLossQuantitySell
    );

    if (!accreditationResult.accessAllowed) {
      setSLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doSellStoploss(marketOrderPrice);
    };

    if (accreditationResult.requiresTermsAgreement) {
      setSLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const checkNumber = (num) => (isNaN(num) ? 0 : num);

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY PANEL ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">Buy Stop-Limit</div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minBuyQty}
                value={stopLossQuantity}
                onChange={(e) => {
                  handleStopLimitAmount(e, "buy");
                  resetSliderBuy();
                }}
                required
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Stop</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossTriggerPrice)}
                onChange={handleInputChange}
                onKeyUp={validateStoplossTriggerPrice}
                required
                pattern="\d+(\.\d{1,8})?"
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Limit</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossPrice)}
                onChange={handleStopLossPriceChange}
                onKeyUp={() => {
                  validateStoplossPrice();
                  calculateAmountFromLimitForStopLoss();
                }}
                required
                pattern="\d+(\.\d{1,8})?"
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossTotal)}
                onChange={(e) => {
                  handleStopLimitTotal(e, "buy");
                  resetSliderBuy();
                }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${progress === pct ? "pct-active-buy" : ""
                  }`}
                onClick={() => {
                  setProgress(pct);
                  getBuySliderValStopLimit(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          {stopLossError && (
            <p style={{ color: "#ef4444", fontSize: 10, marginTop: 4 }}>
              {stopLossError}
            </p>
          )}

          <button
            className="trade-action-btn btn-buy"
            disabled={
              !(
                stopLossTotal > 0 &&
                stopLossPrice > 0 &&
                stopLossTriggerPrice > 0
              ) ||
              loading ||
              Number(stopLossQuantity) < Number(minBuySellAmount?.minBuyQty)
            }
            onClick={() => buyStopLoss()}
          >
            {loading ? "Loading..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL PANEL ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">Sell Stop-Limit</div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedBuyingAssetBalance} {currencycode?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minSellQty}
                value={stopLossQuantitySell}
                onChange={handleStopLimitAmount}
                onKeyUp={validateStopLossAmountSell}
                min="0"
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Stop</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossTriggerPriceSell)}
                onChange={handleChange}
                pattern="\d+(\.\d{1,8})?"
                required
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Limit</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossPriceSell)}
                onChange={(e) => setStopLossPriceSell(e.target.value)}
                onKeyUp={() => {
                  validateStoplossPriceSell();
                  calculateAmountFromLimitForStopLossSell();
                }}
                pattern="\d+(\.\d{1,8})?"
                required
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(stopLossTotalSell)}
                onChange={handleChangeSell}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${sliderValue === pct ? "pct-active-sell" : ""
                  }`}
                onClick={() => {
                  setSliderValue(pct);
                  getSellSliderValStopLimit(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={
              !(
                stopLossTotalSell > 0 &&
                stopLossPriceSell > 0 &&
                stopLossTriggerPriceSell > 0
              ) ||
              sloading ||
              Number(stopLossQuantitySell) <
              Number(minBuySellAmount?.minSellQty)
            }
            onClick={sellStoploss}
          >
            {sloading ? "Loading..." : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />

      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={currencycode}
        txnType={pendingTxnType}
      />
    </div>
  );
};

export default BuyAndSellStopLimit;
